import { AdPlacement } from "@/components/ads/AdPlacement";
import { TypingBreadcrumb } from "../components/TypingBreadcrumb";
import { TypingExplainer } from "../components/TypingExplainer";
import { TypingMoreLinks } from "../components/TypingMoreLinks";
import { TypingTest } from "../components/TypingTest";
import type { TypingVariant } from "../lib/variants";

/** Generic page for a duration variant, rendered from its config. */
export function VariantPage({ variant }: { variant: TypingVariant }) {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <TypingBreadcrumb current={variant.navName()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {variant.h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {variant.intro()}
          </p>
        </header>

        {/* key remounts the test (resets duration) when switching variants. */}
        <TypingTest key={variant.slug} durationSec={variant.durationSec} />

        <TypingExplainer
          howTo={variant.howTo()}
          faqs={variant.faqs.map((f) => ({ q: f.q(), a: f.a() }))}
        />

        <AdPlacement className="mt-10" />
        <TypingMoreLinks currentSlug={variant.slug} />
      </div>
    </div>
  );
}
